// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.Settings.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { observe } from 'mobx';
import React, { Component, PropTypes } from 'react';
import uiState from 'logic/Izenda.UiState';
import AppStore from 'logic/Izenda.AppStore';
import constants from 'logic/data/Izenda.SettingsContextMenuConstants';
import connect from 'share/enhancers/Izenda.Connect';
import SettingsLevel from './SettingsLevel/Izenda.SettingsLevel';
import Sidebar from 'share/components/layout/Izenda.Sidebar';
import MainContent from 'share/components/layout/Izenda.MainContent';
import MainWrapper from 'share/components/layout/Izenda.MainWrapper';
import SettingsLeftMenu from './Izenda.SettingsLeftMenu';
import SettingsContent from './Izenda.SettingsContent';

@connect()
export default class Settings extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired
  };

  componentDidMount() {
    const props = this.props;
    const { loader, store: { contextMenu } } = props;

    if (contextMenu.activeLink) {
      loader.startLoading();
      props.store.checkSettingLevel();
      // load system indicator for detecting changes
      contextMenu.loadSystemIndicator();
      contextMenu.disabledLinkBasedOnConnectionString().finally(loader.endLoading.bind(loader));
    }

    /**
     * observe detectChangeCount to invoke loadSystemIndicator
     */
    this.disposeReconnectBtnEvent = observe(uiState, 'detectChangeCount', changeCount => {
      changeCount > 0 && contextMenu.loadSystemIndicator();
    });

    this.disposeDetectVisibleConnectionString = observe(uiState, 'detectChangeVisibleConnection', changeCount => {
      changeCount > 0 && contextMenu.disabledLinkBasedOnConnectionString();
    });

    this.disposeObserveTenantID = observe(uiState, 'tenantId', () => {
      // reload app settings
      AppStore.loadAppSettings();

      loader.startLoading();
      contextMenu.loadSystemIndicator();
      contextMenu
        .disabledLinkBasedOnConnectionString()
        .then(() => {
          if (contextMenu.isCurrentActiveLinkDisable) {
            props
              .confirmFn('Confirmation', {
                description: constants.CONFIRM_MESSAGE_CHANGE_TENANT,
                showCancel: false
              })
              .then(contextMenu.changeActiveLink.bind(contextMenu, constants.CONTEXT_MENU_REVERT_LINK));
          }
        })
        .finally(loader.endLoading.bind(loader));
    });
  }

  componentWillUnmount() {
    this.disposeReconnectBtnEvent();
    this.disposeDetectVisibleConnectionString();
    this.disposeObserveTenantID();
    // re-enable System Setting dropdown when exiting Settings tab
    uiState.enableSystemSetting();
    this.props.store.onlyShowTenant(false);
  }

  render() {
    const { store, hasSetupDatabase, params } = this.props;
    return (
      <section className="izenda-Wrapper">
        <SettingsLevel store={store} />
        <MainWrapper>
          <div className="izenda-TableLayout u_paddingTopBottom">
            <Sidebar>
              <SettingsLeftMenu store={store} hasSetupDatabase={hasSetupDatabase} />
            </Sidebar>
            <MainContent>
              <SettingsContent store={store} params={params} hasSetupDatabase={hasSetupDatabase} />
            </MainContent>
          </div>
        </MainWrapper>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/Settings/Izenda.Settings.js